import ControlsVerticalDoubleChevron from "@casino/external/icons/ControlsVerticalDoubleChevron";
import Button from "@casino/legacyUi/Button";

type Props = {
  onClick?: () => void;
  fullWidth: boolean;
};

const IconButton: FC<Props> = ({ children, onClick, fullWidth }) => (
  <Button
    className="justify-between font-normal text-muted-foreground ring-border md:min-w-[11.25rem]"
    size="lg"
    iconRight={<ControlsVerticalDoubleChevron />}
    onClick={onClick}
    fullWidth={fullWidth}
    variant="secondary"
  >
    {children}
  </Button>
);

export default IconButton;
